import { render, staticRenderFns } from "./updateCustomer.vue?vue&type=template&id=56565304&"
import script from "./updateCustomer.vue?vue&type=script&lang=js&"
export * from "./updateCustomer.vue?vue&type=script&lang=js&"
import style0 from "./updateCustomer.vue?vue&type=style&index=0&id=56565304&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports